module.exports = __webpack_public_path__ + "img/btn_order_all_open02.1f3c21da.svg";